import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useFormik } from 'formik';

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormLabel from '@mui/material/FormLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import axios from 'utils/axios-rails';

import AppInput from 'shared/AppInput';
import AppNotification from 'shared/AppNotification';

const propTypes = {
  submitURL: PropTypes.string.isRequired,
  employees_count_options: PropTypes.array.isRequired,
  sector_options: PropTypes.array.isRequired,
  company_department_options: PropTypes.array.isRequired,

  locationsDataset: PropTypes.object.isRequired,
  country: PropTypes.string.isRequired,
  showEconomicActivityCode: PropTypes.bool.isRequired,
}

const defaultProps = {

}

// Labelled select matching AppInput's "static label above the field" style.
const SelectField = ({ label, name, value, onChange, options }) => (
  <>
    <FormLabel component="label" sx={{ display: "block", mb: 0.5 }}>{ label }</FormLabel>
    <TextField select fullWidth size="small" name={ name } value={ value || "" } onChange={ onChange }>
      { options.map( (option, index) =>
        <MenuItem key={ option.value } value={ option.value }>{ option.label }</MenuItem>
      )}
    </TextField>
  </>
);

// Iframe reference (to allow submit and redirection)
// <iframe id="shogunBusinessIframe" sandbox="allow-scripts allow-top-navigation allow-forms allow-top-navigation-by-user-activation allow-same-origin" style="border: none;" width="100%"  src="https://factura.unimart.com/business_applications/new" title="Business SignUp"></iframe>
const UnimartBusinessSignUp = (props) => {
  const [displaySuccess, setDisplaySuccess] = useState(false);

  const closeToast = () => setDisplaySuccess(false);

  const handleSubmit = async (values) => {
    console.log(values);
    try {
      const response = await axios.post(props.submitURL, {
        business_application: values
      });
      formik.resetForm();
      setDisplaySuccess(true);
      window.top.location.href = "https://www.unimart.com/pages/thankyouregistro-unimart-business"
    } catch (error) {
      const ex = error;
      if(error.response && error.response.data && error.response.status != 500){
        console.log("Errors", error.response.data);
        formik.setErrors(error.response.data);
      } // errors
      else{
        formik.setErrors({ general: "Ocurrió un error con la conexión. Por favor intente de nuevo o recargue la página" });
      }
    }
    formik.setSubmitting(false);
  }

  const formik = useFormik({
    initialValues: {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      company_name: '',
      national_id: '',
      economic_activity_code: '',
      canton: '',
      province: '',
      address: '',
      sector: '',
      employees_count: '',
      district: '',
      company_department:'',
      country: props.country,
    },
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const { values } = formik;

  return (
    <div id="UnimartBusinessFormContainer" className="app-container">
      <form style={{ position: "relative" }} className="pv28 ph12" onSubmit={ formik.handleSubmit } >

        <AppNotification
          open={ displaySuccess }
          message="Envíado con éxito"
          severity="success"
          handleClose={ closeToast }
          position={{ vertical: 'top', horizontal: 'right' }}
        />

        { formik.errors.general && <Typography variant="body1" color="error" className="mb20">{ formik.errors.general }</Typography> }

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <AppInput
              label="Nombre"
              name="first_name"
              value={ values.first_name } onChange={ formik.handleChange } placeholder=""
              error={ formik.errors.first_name }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AppInput
              label="Apellidos"
              name="last_name" value={ values.last_name } onChange={ formik.handleChange } placeholder=""
              error={ formik.errors.last_name } />
          </Grid>

          <Grid item xs={12} sm={6}>
            <AppInput
              label="Correo electrónico empresarial"
              name="email" value={ values.email } onChange={ formik.handleChange } type="email" placeholder=""
              error={ formik.errors.email } />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AppInput
              label="Teléfono"
              name="phone" value={ values.phone } onChange={ formik.handleChange } placeholder=""
              error={ formik.errors.phone } />
          </Grid>

          <Grid item xs={12} sm={6}>
            <AppInput
              label="Nombre de empresa"
              name="company_name" value={ values.company_name } onChange={ formik.handleChange } placeholder=""
              error={ formik.errors.company_name } />
          </Grid>
          <Grid item xs={12} sm={6}>
            <AppInput
              label="Cédula jurídica"
              name="national_id" value={ values.national_id } onChange={ formik.handleChange } type="number" placeholder=""
              error={ formik.errors.national_id } />
          </Grid>

          {/* Only required on CR */}
          { props.showEconomicActivityCode &&
            <Grid item xs={12} sm={6}>
              <AppInput
                label="Código de actividad económica"
                name="economic_activity_code" value={ values.economic_activity_code } onChange={ formik.handleChange } type="number" placeholder=""
                error={ formik.errors.economic_activity_code }
              />
            </Grid>
          }

          <Grid item xs={12} sm={props.showEconomicActivityCode ? 6 : 12}>
            <SelectField
              label="Departamento" name="company_department"
              value={ values.company_department } onChange={ formik.handleChange }
              options={ props.company_department_options }
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <SelectField
              label="Sector" name="sector"
              value={ values.sector } onChange={ formik.handleChange }
              options={ props.sector_options }
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <SelectField
              label="Cantidad de empleados" name="employees_count"
              value={ values.employees_count } onChange={ formik.handleChange }
              options={ props.employees_count_options }
            />
          </Grid>
        </Grid>

        <div className="flex mt20">
          <Button
            className="border-0 pv8 ph16 font-weight-bold"
            color="brandYellow"
            variant="contained"
            disableElevation
            fullWidth
            type="submit"
            disabled={ formik.isSubmitting }
          >
            { formik.isSubmitting ? "ENVIANDO..." : "SOLICITAR CUENTA GRATUITA" }
          </Button>
        </div>
      </form>
    </div>
  )
};

UnimartBusinessSignUp.propTypes = propTypes;
UnimartBusinessSignUp.defaultProps = defaultProps;

export default UnimartBusinessSignUp;
